(ns manage.adset-template-page.view.templates-panel
  (:require ["@mui/material/Alert$default" :as Alert]
            ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["src/svg/artwork/template.svg$default" :as TemplateArtwork]
            [cljs-bean.core :refer [->clj]]
            [clojure.data :refer [diff]]
            [common.modal.dialog :refer [deletion-confirmation form-dialog]]
            [common.modal.view :refer [defmodal]]
            [common.ocp.view :refer [defocp ocp]]
            [common.patterns.empty-state-view :refer [empty-state-view]]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.url-template :as url-tpl]
            [common.util :refer [spread-obj]]
            [common.widgets.dropdown :refer [dropdown]]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-template-page.db.db :as db]
            [manage.adset-template-table.view :as template-table.view]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def ^:private placeholder-type-icon-map
  {"image" "image"
   "text" "text_fields"
   "video" "videocam"
   "audio" "audiotrack"
   "click" "link"
   "click-tracker" "contacts"
   "impression-tracker" "view_agenda"
   "collection" "article"})

(defmodal confirm-delete ::confirm-delete
  [{:keys [id]}]
  (let [{:keys [campaign-id adset-id]} (use-subscribe [:url-context])
        {adset :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))
        {put-template :mutate} (use-mutation (adset-queries/put-template-mutation {:adset-id adset-id :campaign-id campaign-id}))
        delete-template (uix/use-callback (fn []
                                            (put-template (adset-queries/remove-template-from-adset adset id)))
                                          [adset put-template id])]
    [deletion-confirmation
     {:on-submit #(delete-template)
      :entity-name "Template"}]))

(defmodal warning ::warning
  [props]
  [form-dialog
   (merge {:modifier :warning
           :submit-button-testid "confirm"}
          (dissoc props :body))
   [:> Typography
    {:sx {:minWidth "30rem"}}
    (:body props)]])

(defui empty-view []
  (let [url-context (use-subscribe [:url-context])
        {adset-exported :data} (use-query (spread-obj (adset-queries/adset-exports-history-query url-context)
                                                      #js {:select (fn [^js data]
                                                                     (let [data (->clj data)]
                                                                       (boolean (seq data))))}))
        {{:keys [channel]} :data} (use-query (adset-queries/adset-query url-context))]
    ($ empty-state-view
       {:title "Add your template(s)"
        :description "Add templates to start ad creation. Whether for products, services,
                    or your brand, find your fit. Let's craft your variants! 🎨"
        :artwork TemplateArtwork
        :docs-href (url-tpl/render :docs/article (assoc url-context :slug "24154930918812-Understanding-Templates"))
        :actions ($ template-table.view/assign-template-button
                    {:adset-exported adset-exported
                     :adset-channel channel
                     :has-assigned-template? false
                     :data-testid "empty-view-open-templates-modal-button"})})))

(defui templates-panel []
  (let [{:keys [adset-id]} (use-subscribe [:url-context])
        {:keys [isPending] templates :data} (use-query (adset-queries/adset-template-query {:adset-id adset-id}))]
    (uix/use-effect (fn []
                      (rf/dispatch [:page.adset-template/init])
                      (fn []
                        (rf/dispatch [:page.adset-template/destroy])))
                    [])
    (cond
      isPending ($ loading-view)
      (pos? (count templates)) ($ template-table.view/template-data-grid)
      :else ($ empty-view))))

(defui placeholder-field
  [{:keys [type ph-name]}]
  ($ Stack
     {:direction "row"}
     ($ Stack
        {:direction "row"
         :spacing 0.5
         :alignItems "center"
         :sx #js {:flex 1}}
        ($ Icon
           {:fontSize "small"}
           (placeholder-type-icon-map type))
        ($ Typography
           {:sx #js {:textTransform "capitalize"}}
           type))
     ($ Box
        {:sx #js {:flex 1}}
        ($ Typography (name ph-name)))))

(defui placeholder-block
  [{:keys [title placeholders]}]
  ($ form-field
     {:label title}
     ($ Stack
        {:spacing 1}
        (for [[ph-name {:keys [type]}] placeholders]
          ($ placeholder-field {:key ph-name :type type :ph-name ph-name})))))

(defocp template-revision-ocp :template-revision/crud [{:keys [template]}]
  (uix/use-effect (fn []
                    (rf/dispatch [:page.adset-template/init-revision-ocp template]))
                  [template])
  (let [{:keys [campaign-id adset-id]} (use-subscribe [:url-context])
        {templates :data} (use-query (adset-queries/adset-template-query {:adset-id adset-id}))
        edit-allowed (use-subscribe [:resource.user/allowed? "templates.edit"])
        current-template (use-subscribe [:page.adset-template/current-template])
        revision-options (use-subscribe [:page.adset-template/revision-options (:id current-template)])
        old-revision (use-subscribe [:page.adset-template/old-revision (:id current-template)])
        latest-revision (use-subscribe [:page.adset-template/latest-revision (:id current-template)])
        revision-differences (diff old-revision (first (:revisions current-template)))
        placeholder-differences (diff (:placeholders old-revision) (:placeholders (first (:revisions current-template))))

        {put-template :mutate} (use-mutation (adset-queries/put-template-mutation {:adset-id adset-id :campaign-id campaign-id}))
        save-revision-update (uix/use-callback (fn []
                                                 (let [template->payload-item (fn [{:keys [id revisions]}]
                                                                                {:templateId id
                                                                                 :version (:version (first revisions))})
                                                       payload (->> templates
                                                                    (map #(template->payload-item
                                                                           (if (= (:id %) (:id current-template))
                                                                             current-template
                                                                             %))))]
                                                   (put-template payload
                                                                 #js {:onSuccess #(rf/dispatch [:ocp/close])})))
                                               [templates current-template put-template])]
    ($ ocp
       {:title "Manage Template Version"
        :footer (when edit-allowed
                  ($ Button
                     {:variant "contained"
                      :type :submit}
                     "Save Template Version"))
        :on-submit save-revision-update}

       (when-not edit-allowed
         ($ Alert {:severity "warning"}
            "You don't have the appropriate rights to update templates. Please contact your administrator."))

       ($ form-field
          {:label "Name"}
          ($ Typography {:no-wrap true} (:name current-template)))

       ($ form-field
          {:label "Version"}
          (if edit-allowed
            ($ Stack
               {:direction "row"
                :spacing 2}
               (r/as-element
                [dropdown
                 {:value (first (:revisionIds current-template))
                  :options revision-options
                  :on-change #(rf/dispatch [:page.adset-template/set-revision
                                            {:template current-template
                                             :revision-id %}])
                  :sx #js {:flex 2}}])
               ($ Button
                  {:startIcon ($ Icon "arrow_upward")
                   :variant "text"
                   :on-click #(rf/dispatch [:page.adset-template/set-revision
                                            {:template current-template
                                             :revision-id (:id latest-revision)}])
                   :sx #js {:whiteSpace "nowrap"
                            :flex 1}}
                  "Select latest"))
            ($ :span (db/revision->label old-revision))))

       ($ form-field
          {:label "Template Type"}
          ($ :span (:templateType latest-revision)))

       ($ form-field
          {:label "Size"}
          ($ Stack
             {:spacing 1}
             ($ Stack
                {:direction "row"
                 :spacing 1}
                ($ :span "Current:")
                ($ Typography
                   {:sx #js {:textDecorationLine (when (first revision-differences)
                                                   "line-through")}}
                   (:width old-revision) "x" (:height old-revision)))

             (when (first revision-differences)
               ($ Stack
                  {:direction "row"
                   :spacing 1}
                  ($ :span "New:")
                  ($ :span
                     (:width (first (:revisions current-template))) "x" (:height (first (:revisions current-template))))))))

       ($ placeholder-block {:title "Placeholders"
                             :placeholders (nth placeholder-differences 2)})
       (when (first placeholder-differences)
         ($ placeholder-block {:title "Deleted Placeholders"
                               :placeholders (first placeholder-differences)}))
       (when (second placeholder-differences)
         ($ placeholder-block {:title "Added Placeholders"
                               :placeholders (second placeholder-differences)})))))
